import { render, staticRenderFns } from "./RealtimeScreen.vue?vue&type=template&id=2ed97a37&scoped=true"
import script from "./RealtimeScreen.vue?vue&type=script&lang=js"
export * from "./RealtimeScreen.vue?vue&type=script&lang=js"
import style0 from "./RealtimeScreen.vue?vue&type=style&index=0&id=2ed97a37&prod&scoped=true&lang=css"
import style1 from "./RealtimeScreen.vue?vue&type=style&index=1&id=2ed97a37&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed97a37",
  null
  
)

export default component.exports